 

class ApplicationReviewDirective implements ng.IDirective {
    restrict = 'AE'
    controller = ApplicationReviewController
    controllerAs = '$ctrl'
    bindToController = true
    templateUrl = 'controls/ApplicationReview/applicationReview.html'
    scope = {
        applicationId: '=',
        init: '=?',
        initUsers: '=?'
    }
}

class ApplicationReviewController {
    applicationId: number
    init: boolean;
    initUsers;

    reviewingByMe: boolean;
    reviewingByOther: boolean;
    reviewerTitle: string;
    users;

    static $inject = ['$scope', 'PushHub', 'Auth'];
    constructor(private $scope, private PushHub, private Auth) {
            
        $scope.$on('push:applicationObserversChange', (event, message) => {
            if (this.applicationId === message.applicationId) {

                this.update(message.users);
            }
        });
    }

    $onInit() {
        if (this.init) {
            this.update(this.initUsers || []);
        } else {
            this.PushHub.getApplicationObservers().then((observers) => {
                this.update(observers || []);
            });
        }
    }

    private update(users) {
        this.users = users;

        this.Auth.user.userId

        if (users.length == 0) {
            this.reviewingByMe = false;
            this.reviewingByOther = false;
            this.reviewerTitle = '';

        } else if (users.length == 1 && users[0].userId == this.Auth.user.userId) {
            
            this.reviewingByMe = true;
            this.reviewingByOther = false;
            this.reviewerTitle = '';
        } else {
            this.reviewingByMe = false;
            this.reviewingByOther = true;
            let otherUsers = users.filter(user => user.userId !== this.Auth.user.userId).map(user => user.name);
            if (otherUsers.length == 1) {
                this.reviewerTitle = `${otherUsers[0]} is reviewing`;
            } else {
                this.reviewerTitle = `${otherUsers.join(", ")} are reviewing`;
            }
        } 
    }
}


angular
    .module('app')
    .directive('applicationReview', () => new ApplicationReviewDirective());